import React from 'react';
import { Row, Col } from 'reactstrap';
import CallToActionBlock, {
  type CallToActionBlockProps,
} from './CallToActionBlock';

function BlockGroupingOneOne({
  blocks,
}: {
  blocks: { block1: CallToActionBlockProps; block2: CallToActionBlockProps };
}) {
  return (
    <Row className="block-grouping-1-1 g-0">
      <Col xs={12} md={6} className="block-1 pe-md-1 pb-1 pb-md-0">
        <Row className="g-0 h-100">
          <Col className="h-100">
            <CallToActionBlock
              block={blocks.block1 as CallToActionBlockProps}
            />
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={6} className="block-2 ps-md-1 pt-1 pt-md-0">
        <Row className="g-0 h-100">
          <Col className="h-100">
            <CallToActionBlock
              block={blocks.block2 as CallToActionBlockProps}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default BlockGroupingOneOne;
